import Core from "@/modules/core/service/Core";

export default {
    props: {
        entry: {

        },

        header: {
            required: false,
            type    : Boolean,
            default : () => {
                return false;
            }
        },

        removeable: {

        },

        borderType: {

        }
    },

    computed: {
        selected () {
            return this.$store.getters.context.site;
        },

        unit () {
            if (!this.entry) {
                return null;
            }

            return this.entry.unit;
        },

        border () {
            return this.unit && this.selected === this.unit.id ? 'primary-border-thick ' : '';
        },

        status () {
            console.log(this.entry)
            return "S";
        },

        border2 () {
            switch (this.borderType) {
                case "top"   : return "top-border-radius " + this.border;
                case "bottom": return "bottom-border-radius " + this.border;
            }

            return "middle-border-radius " + this.border;
        }
    },

    methods: {
        onRemove () {
            this.$emit("remove", this.unit);
        },

        background (hover) {
            return hover ? 'primary white--text' : ' black--text'
        },

        dateAsString (value) {
            if (!value) {
                return "---";
            }

            return Core.format.date.display(value);
        },

        moneyAsString (value) {
            if (!value) {
                return "---";
            }

            return Core.format.money(value);
        },

        toHtml (text) {
            return Core.format.html(text);
        },


    }
}